import { render, staticRenderFns } from "./account-login.vue?vue&type=template&id=0aff46cf&scoped=true&"
import script from "./account-login.vue?vue&type=script&lang=js&"
export * from "./account-login.vue?vue&type=script&lang=js&"
import style0 from "./account-login.vue?vue&type=style&index=0&id=0aff46cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff46cf",
  null
  
)

export default component.exports